import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { IemService } from './iem.service';
import { CustomHttpParams } from '../models/CustomHttpParams.class';
import Utils, { UUIDRegex } from '@uigy/utils';

export const iemInterceptor: HttpInterceptorFn = (req, next) => {
  const iemService = inject(IemService);

  const httpBlock: boolean = req.params instanceof CustomHttpParams && req.params.overrideIEM;
  const graphBlock: boolean = req.headers.has('overrideIEM');
  const machineIdHeader: string | undefined = req.headers.get('machineId') ?? undefined;

  let modifiedReq = req;

  if (UUIDRegex.test(Utils.getBasePath()) && !req.url.includes('loginurl') && !graphBlock && !httpBlock) {
    modifiedReq = modifiedReq.clone({ url: `/${Utils.getBasePath()}${modifiedReq.url}` });
  }

  if (graphBlock) {
    modifiedReq = modifiedReq.clone({ headers: modifiedReq.headers.delete('overrideIEM') });
  }

  if (modifiedReq.headers.has('machineId')) {
    modifiedReq = modifiedReq.clone({ headers: modifiedReq.headers.delete('machineId') });
  }

  if (!graphBlock && !httpBlock) {
    modifiedReq = modifiedReq.clone({
      url: iemService.addSitePrefix(modifiedReq.url, machineIdHeader),
    });
  }

  return next(modifiedReq);
};
